import { motion } from "framer-motion";

const FRAMES = Array.from({ length: 12 }, (_, i) => `/art/worlds/world_alt_${i}.jpg`);

export default function FilmStripSection() {
  const strip = [...FRAMES, ...FRAMES];
  return (
    <section
      id="film-strip"
      data-testid="film-strip-section"
      className="relative w-full py-20 sm:py-28 overflow-hidden bg-[#050505]"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(255,90,0,0.14),transparent_62%)]" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 text-center px-6 mb-14 sm:mb-20"
      >
        <p
          data-testid="film-strip-studio"
          className="font-display uppercase text-[#f5f0e8] leading-none"
          style={{
            fontSize: "clamp(1.5rem, 3.4vw, 3rem)",
            letterSpacing: "0.15em",
          }}
        >
          Resilience Studios
        </p>
        <p
          data-testid="film-strip-presents"
          className="font-body italic text-[#a1a1aa] mt-3 mb-8"
          style={{ fontSize: "clamp(1rem, 1.6vw, 1.5rem)" }}
        >
          presents
        </p>
        <h2
          data-testid="film-strip-headline"
          className="font-display uppercase text-[#f5f0e8] leading-[0.9] tracking-tight"
          style={{ fontSize: "clamp(2.5rem, 8vw, 7rem)" }}
        >
          The Twelve Worlds
          <br />
          <span className="italic text-[#ff5a00]">Are Coming…</span>
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2, delay: 0.15 }}
        className="film-reel w-full"
      >
        <div className="reel-holes" />
        <div className="marquee-track py-2">
          {strip.map((src, i) => (
            <div key={i} className="reel-frame" style={{ backgroundImage: `url(${src})` }} aria-hidden="true" />
          ))}
        </div>
        <div className="reel-holes" />
      </motion.div>
    </section>
  );
}
